// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pf-c";
export var backButton = "_pf-4";
export var backIcon = "_pf-5";
export var chevronShortcut = "_pf-6";
export var container = "_pf-1";
export var editor = "_pf-8";
export var editorWrapper = "_pf-7";
export var prefix = "_pf-2";
export var searchIcon = "_pf-3";
export var suffix = "_pf-9";
export var suffixContent = "_pf-a";
export var suffixText = "_pf-b";
export var wrapper = "_pf-0";